import { Toast } from 'primereact/toast';
import { FC, MutableRefObject } from 'react';

interface Props {
  successfullToastRef: MutableRefObject<Toast | null>;
}

const ToastSuccessful: FC<Props> = ({ successfullToastRef }) => {
  return (
    <Toast
      ref={successfullToastRef}
      appendTo={document.body}
      position="bottom-center"
      content={({ message }) => (
        <section
          className="nc_toast-align px-3 py-1 w-full"
          style={{ borderRadius: '6px', backgroundColor: '#008158' }}
        >
          <span className="pi pi-check ml-2" style={{ fontSize: '1.5rem', color: '#FFFFFF' }}></span>
          <p className="text-white nc_toast-font-family">{message?.summary}</p>
        </section>
      )}
    ></Toast>
  );
};

export default ToastSuccessful;
